import { Fragment, PropsWithChildren, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const PostChecker = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (state === null || state?.id === null) navigate('/experiences');
  }, [state]);

  return null;
};
